/* eslint-disable arrow-body-style */
import { SelectInput } from '@abyss/web/ui/SelectInput';
import React from 'react';
import { constants } from '@src/routes/provider/common/constants';
import { riskScoresId } from '../../types';
import {
  riskScoresFilterPanelsApi,
  useRiskScoreFilterPanelStore,
} from '../../mothership/riskScoresFilterPanel.state';

export const FraudTypeSelect = () => {
  const options = useRiskScoreFilterPanelStore(
    (state) => state.fraudTypeOptions
  );
  const value = useRiskScoreFilterPanelStore((state) => state.fraudType);
  const loading = useRiskScoreFilterPanelStore((state) => state.loading);
  const placeholder = loading ? constants.LOADING : 'Select a Fraud Type';
  const renderValue = loading ? '' : value;

  const { setFraudTypeValue: setFraudType } = riskScoresFilterPanelsApi;

  return (
    <div
      data-cy={`${riskScoresId}SelectFraudType`}
      data-value={value}
      data-options={JSON.stringify(options)}
    >
      <SelectInput
        label="Fraud Type"
        placeholder={placeholder}
        value={renderValue}
        onChange={setFraudType}
        options={options}
      />
    </div>
  );
};
